function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Component } from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';
import Icon from '@material-ui/core/Icon';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "inherit",
    display: "flex",
    margin: theme.spacing(-0.5)
  },
  button: {
    padding: theme.spacing(0.5)
  },
  icon: {
    fontSize: "18px",
    marginRight: theme.spacing(1)
  },
  label: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "14px",
    fontWeight: "bold"
  }
}));

const ToolbarButton = ({
  icon,
  label,
  title,
  onClick
}) => {
  const classes = useStyles();
  return React.createElement(ButtonBase, {
    className: classes.button,
    onClick: onClick
  }, icon && React.createElement("i", {
    className: classes.icon
  }, React.createElement(Icon, null, icon)), React.createElement("b", {
    className: classes.label
  }, label || title));
};

const FinderToolbar = ({
  buttons = []
}) => {
  const classes = useStyles();

  if (!buttons.length) {
    return null;
  }

  return React.createElement("nav", {
    className: classes.root
  }, buttons.map((button, index) => {
    return React.createElement(ToolbarButton, _extends({}, button, {
      key: index
    }));
  }));
};

export default FinderToolbar;